import type { ChipProps } from '@mui/material';
import type { IHomeTabDef } from '../interfaces';

export const HOME_TABS: IHomeTabDef[] = [
  { label: 'Job Opening', value: 'Job Opening' },
  { label: 'Assessment', value: 'Assessment' },
  { label: 'User', value: 'User' },
];

export const HOME_ROWS_PER_PAGE = 5;
export const HOME_USERS_ROWS_PER_PAGE = 10;
export const HOME_SEARCH_DEBOUNCE_MS = 500;

export const PARTICIPANT_PAGE_SIZE = 9;
export const PARTICIPANT_WELLNESS_PAGE_SIZE = 5;

export const HOME_JOB_OPENING_LABEL_ORDER: string[] = [
  'Job Description',
  'Job Posting',
  'Short Listing',
  'Interview',
  'Decision Making',
  'Closed',
];

export const HOME_SESSION_LABELS: string[] = ['Completed', 'Not Completed'];

export const HOME_USER_TYPE_COLOR_MAP: Record<string, ChipProps['color']> = {
  Admin: 'primary',
  Participant: 'default',
  Employee: 'success',
};

export const HOME_STATUS_COLOR_MAP: Record<string, ChipProps['color']> = {
  Active: 'success',
  Pending: 'warning',
  Inactive: 'default',
};
